import { authHeader } from '../_helpers';
import { loginService } from './login.service';

export const menuService = {
    getAll,
    getAllByUsuario,
    getAllByUsuarioWithPadre
};

const urlApi = `${process.env.REACT_APP_URL_API}menu/`;

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${urlApi}getall`, requestOptions).then(handleResponse);
}

function getAllByUsuario(idUsuario) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${urlApi}getallbyusuario/${idUsuario}`, requestOptions).then(handleResponse);
}

function getAllByUsuarioWithPadre() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${urlApi}getallbyusuariowithpadre`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        if (!response.ok) {
            if (response.status === 401) { //sin autorizar
                loginService.logout();
                window.location.reload();
            }
        
            const error = (data && data.Message) || response.statusText;
            return (error);
        }

        return data;
    });
}